import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BulkSelectionMode} from './bulk-selection.state';

/**
 * Presentation-only bulk selection banner.
 * Parents own selection state, filters, delete, refresh, and permissions.
 */
@Component({
    selector: 'app-shared-bulk-selection-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './shared-bulk-selection-banner.component.html',
    styleUrl: './shared-bulk-selection-banner.component.css',
})
export class SharedBulkSelectionBannerComponent {
    @Input() visible = false;
    @Input() selectedCount = 0;
    @Input() matchingCount = 0;
    @Input() mode: BulkSelectionMode = 'page';
    @Input() showSelectAllMatching = false;
    @Input() itemLabel = 'items';

    @Output() selectAllMatching = new EventEmitter<void>();
    @Output() clearSelection = new EventEmitter<void>();

    get selectionCopy(): string {
        if (this.mode === 'all_filtered') {
            return `All ${this.selectedCount} matching ${this.itemLabel} selected`;
        }
        const noun = this.selectedCount === 1 ? this.singularLabel : this.itemLabel;
        return `${this.selectedCount} ${noun} selected`;
    }

    get singularLabel(): string {
        if (this.itemLabel.endsWith('s') && this.itemLabel.length > 1) {
            return this.itemLabel.slice(0, -1);
        }
        return this.itemLabel;
    }

    onSelectAllMatching(): void {
        this.selectAllMatching.emit();
    }

    onClearSelection(): void {
        this.clearSelection.emit();
    }
}
